import { Navigate } from "react-router-dom";

// ProtectedRoute component to check authentication & role
const ProtectedRoute = ({ children, allowedRoles }) => {
  const authToken = localStorage.getItem("authToken");
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));

  // If user is not logged in, redirect to login page
  if (!authToken || !userProfile) {
    return <Navigate to="/" />;
  }

  // If user's role is not in allowedRoles, redirect to unauthorized page
  if (!allowedRoles.includes(userProfile.user_type)) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
